document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".collection-carousel");
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const slider = carousel.querySelector(".collectionSlider");
    const wrapper = carousel.querySelector(".swiper-wrapper");
    if (!slider || !wrapper) return;

    if (slider.classList.contains("swiper-initialized")) return;

    const slidesQty = parseFloat(carousel.dataset.slides) || 1;
    const slidesGap = parseFloat(carousel.dataset.gap) || 0;
    const slidesQtyMobile = parseFloat(carousel.dataset.slidesMobile) || 1;
    const slidesGapMobile = parseFloat(carousel.dataset.gapMobile) || 0;

    const productsSource = carousel.dataset.productsSource || "collection";

    const initSwiper = () => {
      if (slider.classList.contains("swiper-initialized")) return;

      new Swiper(slider, {
        touchStartPreventDefault: false,
        touchMoveStopPropagation: true,

        navigation: {
          nextEl: carousel.querySelector(".collection-carousel-slider__button-next"),
          prevEl: carousel.querySelector(".collection-carousel-slider__button-prev"),
        },

        breakpoints: {
          0: {
            slidesPerView: slidesQtyMobile,
            spaceBetween: slidesGapMobile,
          },
          900: {
            slidesPerView: slidesQty,
            spaceBetween: slidesGap,
          },
        },
      });
    };

    const hideCarousel = () => {
      carousel.style.display = "none";
    };

    /* ================================
       PRODUCT RECOMMENDATIONS
    ================================= */
    if (productsSource === "recommendations") {
      const recommendationsUrl = carousel.dataset.recommendationsUrl;

      if (!recommendationsUrl) {
        hideCarousel();
        return;
      }

      fetch(recommendationsUrl)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const sectionId = carousel.dataset.sectionId;
          const fetchedCarousel = doc.querySelector(`.collection-carousel[data-section-id="${sectionId}"]`);
          const fetchedWrapper = fetchedCarousel?.querySelector(".swiper-wrapper");
          const fetchedSlides = fetchedWrapper?.querySelectorAll(".swiper-slide");

          if (!fetchedWrapper || !fetchedSlides || !fetchedSlides.length) {
            hideCarousel();
            return;
          }

          wrapper.innerHTML = fetchedWrapper.innerHTML;
          initSwiper();
        })
        .catch(() => {
          hideCarousel();
        });

      return;
    }

    /* ================================
       RECENTLY VIEWED LOGIC
    ================================= */
    if (productsSource === "recently_viewed") {
      const limit = 10;
      const saved = JSON.parse(localStorage.getItem("glozin__recently-viewed-products") || "[]");

      if (!saved.length) {
        const emptyMessage = document.createElement("div");
        emptyMessage.className = "recently-viewed-empty";
        emptyMessage.innerHTML = `
          <div class="recently-viewed-empty__text">
            In this time you haven't viewed any products.<br>
            <a href="/collections/all" class="recently-viewed-empty__link">
              Browse our catalog
            </a>
            — maybe you'll find something interesting for you.
          </div>
        `;
        wrapper.appendChild(emptyMessage);
        initSwiper();
        return;
      }

      const query = saved.slice(0, limit).join("%20OR%20id:");
      const url = `/search?view=recently-viewed-products&q=id:${query}`;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const div = document.createElement("div");
          div.innerHTML = html;

          div.querySelectorAll(".recently-viewed-product-card").forEach((product) => {
            const slide = document.createElement("div");
            slide.className = "swiper-slide";
            slide.innerHTML = product.outerHTML;
            wrapper.appendChild(slide);
          });

          initSwiper();
        })
        .catch(() => {
          initSwiper();
        });

      return;
    }

    /* ================================
       COLLECTION SOURCE
    ================================= */
    initSwiper();
  });
});
